import { render, staticRenderFns } from "./BankUndepositedFundView.vue?vue&type=template&id=50daf086"
import script from "./BankUndepositedFundView.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50daf086')) {
      api.createRecord('50daf086', component.options)
    } else {
      api.reload('50daf086', component.options)
    }
    module.hot.accept("./BankUndepositedFundView.vue?vue&type=template&id=50daf086", function () {
      api.rerender('50daf086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bankundepositedfund/BankUndepositedFundView.vue"
export default component.exports